import { render, staticRenderFns } from "./ProductOrderQuantityListTop.vue?vue&type=template&id=b037a766&"
import script from "./ProductOrderQuantityListTop.vue?vue&type=script&lang=js&"
export * from "./ProductOrderQuantityListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports